import clsx from 'clsx';
import type { DynamicFieldComponentProps } from '../../dynamic-form/dynamic-form.interfaces';
import FieldLabel from '../../labels/field-label';

export interface GrandScoreProps extends DynamicFieldComponentProps<string> {
  totalScore: number;
  maxPossible: number;
  percentage: string;
}

const GrandScore = ({ label, totalScore, maxPossible, percentage, labelStyles }: GrandScoreProps) => {
  const cellStyle = 'table-cell text-left py-2 px-2 break-words text-sm';
  const headerCellStyle = clsx(cellStyle, 'border-b border-gray-3 font-medium');
  const dataCellStyle = clsx(cellStyle, 'font-normal');

  return (
    <>
      {label && <FieldLabel label={label} labelStyles={labelStyles} />}
      <div className="bg-white table w-full border-separate">
        <div className="table-header-group">
          <div className="table-row">
            <div className={headerCellStyle}>Total Score</div>
            <div className={headerCellStyle}>Max Possible</div>
            <div className={headerCellStyle}>Percentage</div>
          </div>
        </div>
        <div className="table-row-group">
          <div className="table-row">
            <div className={dataCellStyle}>{totalScore?.toFixed(2)}</div>
            <div className={dataCellStyle}>{maxPossible?.toFixed(2)}</div>
            <div className={dataCellStyle}>{percentage}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GrandScore;
